import OpenSeadragon from "openseadragon";
import { useEffect, useRef } from "react";

interface Props {
  imageId: string;
  diaryId: string;
  width: number;
  height: number;
}

const IMAGE_API_BASE = "https://api.onb.ac.at/iiif/image/v3";

export function IIIFViewer({ imageId, diaryId, width, height }: Props): JSX.Element {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const tileSource = {
      "@context": "http://iiif.io/api/image/3/context.json",
      id: `${IMAGE_API_BASE}/${diaryId}/${imageId}`,
      type: "ImageService3",
      protocol: "http://iiif.io/api/image",
      profile: "level2",
      width,
      height,
      tiles: [{ width: 1024, height: 1024, scaleFactors: [1, 2, 4, 8, 16, 32] }],
    };
    const viewer = OpenSeadragon({
      element: containerRef.current,
      prefixUrl: "/openseadragon-images/",
      tileSources: tileSource as unknown as OpenSeadragon.TileSource,
      showNavigationControl: true,
      showNavigator: false,
      animationTime: 0.4,
      blendTime: 0.1,
      maxZoomPixelRatio: 4,
    });
    return () => {
      viewer.destroy();
    };
  }, [imageId, diaryId, width, height]);

  return <div ref={containerRef} className="w-full h-full bg-ink rounded-md overflow-hidden" />;
}
